var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.model && _vm.model.IsSuccess)?[_c('h2',[_vm._v(_vm._s(_vm.model.Value.Name))]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.model.Value.Text)}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }